import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { QUOTES_CONFIG } from '../quotes.config';

@Component({
  selector: 'ciwc-cable-diameter-calculator',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './cable-diameter-calculator.component.html',
  styleUrls: ['./cable-diameter-calculator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CableDiameterCalculatorComponent {
  calculatorForm: FormGroup;
  calculatedDiameter: number | null = null;
  factor: number | null = null;
  layUp: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<CableDiameterCalculatorComponent>,
    private fb: FormBuilder,
  ) {
    this.calculatorForm = this.fb.group({
      wireDiameter: [0, [Validators.required, Validators.min(0)]],
      conductorQuantity: [1, [Validators.required, Validators.min(1)]],
    });
  }

  calculate(): void {
    if (this.calculatorForm.valid) {
      const values = this.calculatorForm.value;
      const conductorQuantity =
        values.conductorQuantity as keyof typeof QUOTES_CONFIG.cableDiameter.specs;
      const specs = QUOTES_CONFIG.cableDiameter.specs[conductorQuantity];

      if (specs) {
        // Calculate cable diameter using the factor from specs
        this.calculatedDiameter = specs.factor * values.wireDiameter;
        this.factor = specs.factor;
        this.layUp = specs.layUp;
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
